module.exports = __webpack_public_path__ + "resources/img/img_watchall_lms1_m.4b6ac12cf839de00e4d2723c5fffb33c.png";